// Search products with pagination and query
export const searchProducts = async (params: {
  page: number;
  limit: number;
  q: string;
}) => {
  return await apiClient.get("/api/v1/admin/:storeId/products/search", {
    q: params.q,
  });
};
import { apiClient } from "@/lib/apiClient";
import {
  DiscountRequestDataType,
  BuyXGetYReqBody,
} from "@/types/coupon/discount";

export const generateCouponCode = async () => {
  return await apiClient.post("/api/v1/admin/:storeId/coupons/generate-code");
};

export const getCollections = async () => {
  return await apiClient.get("/api/v1/admin/:storeId/collections");
};

export const getProducts = async (params?: {
  page?: number;
  page_size?: number;
  sort_by?: string;
  sort_order?: string;
  query?: string;
}) => {
  return await apiClient.get("/api/v1/admin/:storeId/products", {
    ...(params?.page && { page: params.page.toString() }),
    ...(params?.page_size && { page_size: params.page_size.toString() }),
    ...(params?.sort_by && { sort_by: params.sort_by }),
    ...(params?.sort_order && { sort_order: params.sort_order }),
    ...(params?.query && { query: params.query }),
  });
};

export const getCouponById = async (id: string) => {
  return await apiClient.get(`/api/v1/admin/:storeId/coupons/${id}`);
};

export const createDiscount = async ({
  discountSlug,
  data,
}: {
  discountSlug: string;
  data: DiscountRequestDataType;
}) => {
  if (discountSlug === "buy-x-get-y") {
    const buyXGetYData = data as BuyXGetYReqBody;
    // Validate Buy X Get Y specific fields
    if (!buyXGetYData.buyXProducts || !buyXGetYData.getYProducts) {
      throw new Error("Buy X Get Y requires both Buy X and Get Y products.");
    }
  }
  return await apiClient.post(
    `/api/v1/admin/:storeId/coupons/${discountSlug}`,
    data,
  );
};
